
import React from "react";

const RazorpayCheckout = () => {
  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handlePayment = async () => {
    // Ensure the Razorpay script is loaded
    const isScriptLoaded = await loadRazorpayScript();
    if (!isScriptLoaded) {
      alert("Failed to load Razorpay SDK. Please try again later.");
      return;
    }

    try {
      // Step 1: Create an order by calling your backend
      const response = await fetch("https://b2bbackend.dxbhabibi.com/create-order", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          amount: 1, // Amount in INR (500 INR)
          currency: "INR",
          receipt: "receipt_123", // Replace with your receipt logic
        }),
      });

      const { order } = await response.json();

      // Step 2: Razorpay options
      const options = {
        key: "rzp_live_fyXllJiRnEXPAg", // Replace with your Razorpay Key ID
        amount: order.amount, // Amount in paise
        currency: order.currency,
        name: "Your Company Name",
        description: "Test Transaction",
        order_id: order.id, // Order ID created on the backend
        handler: async function (response) {
          console.log("Razorpay response:", response);

          // Step 3: Verify payment on the server
          const verificationResponse = await fetch("https://b2bbackend.dxbhabibi.com/process-payment", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              order_id: response.razorpay_order_id,
              payment_id: response.razorpay_payment_id,
              signature: response.razorpay_signature,
            }),
          });

          const result = await verificationResponse.json();

          if (result.success) {
            alert("Payment successful!");
          } else {
            alert("Payment verification failed!");
          }
        },
        prefill: {
          name: "John Doe", // Replace with dynamic user data
          email: "johndoe@example.com", // Replace with dynamic user data
          contact: "9999999999", // Replace with dynamic user data
        },
        theme: {
          color: "#528FF0",
        },
      };

      const razorpay = new window.Razorpay(options); // Ensure Razorpay is available
      razorpay.open();
    } catch (error) {
      console.error("Error during payment:", error);
    }
  };

  return (
    <div>
      <button onClick={handlePayment} style={{ padding: "10px 20px", fontSize: "16px" }}>
        Pay Now
      </button>
    </div>
  );
};

export default RazorpayCheckout;
